import { IColumn } from "@fluentui/react";
import { ITableData } from "../../interfaces/ITableData";

export class DetailListBuilder {
  constructor() {}

  getTableData(result: any[], addFileIcons: boolean = true): ITableData {
    if (!result) {
      return { columns: [], rows: [] };
    }

    const columns = Object.keys(result[0]);
    let columnResult = columns.map<IColumn>((item, index) => {
      return {
        key: index.toString(),
        name: item,
        fieldName: item.toLowerCase(),
        minWidth: 120,
        isResizable: true,
        iconClassName: "",
        isIconOnly: false
      };
    });

    if (addFileIcons) {
      columnResult.unshift({
        key: "fileIcons",
        name: "File Type",
        iconClassName: "",
        fieldName: "fileType",
        isIconOnly: true,
        minWidth: 16,
        maxWidth: 16,
        isResizable: false
      });
    }

    let rows = this.getValues(result, columns);
    return { columns: columnResult, rows };
  }

  getValues = (dataRows: any[], columns: string[]) => {
    let rows = [];
    dataRows.forEach((dataRow, index) => {
      let row = { key: index };
      columns.forEach(item => {
        row[item.toLowerCase()] = dataRow[item];
      });

      rows.push(row);
    });

    return rows;
  };
}
